import { storeSettings } from './settings/store.settings'

export const reducers = {
  [storeSettings.name]: storeSettings.reducer,
}
